import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { MatDialog } from '@angular/material/dialog'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {
  PagedAddressTypeResponse,
  SearchAddressTypeModel,
} from '../../../core/models/address-type.model'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AddressTypeCreateComponent } from '../../../features/address/address-type-create/address-type-create.component'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeEditComponent } from '../../../features/address/address-type-edit/address-type-edit.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { AuthService } from '../../../core/services/auth/auth.service'
import { SearchContactTypeModel } from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'address-type',
  imports: [
    MatCard,
    PaginationComponent,
    TableListComponent,
    AddressTypeCreateComponent,
    MatInputModule,
    MatProgressBar,
    FormSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './address-type.component.html',
  styleUrl: './address-type.component.scss',
  providers: [AddressTypeService, AuthService],
  standalone: true,
})
export class AddressTypeComponent implements OnInit {
  constructor(
    private addressTypeService: AddressTypeService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  loading = true
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  searchForm: SearchAddressTypeModel = new SearchAddressTypeModel()
  inputSearch = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'active',
      key: 'ativo',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen = 'tipo endereço'

  ngOnInit() {
    this.checkColumnAction()
    this.getTypeAddress()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchTypeAddress()
    } else {
      this.getTypeAddress()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }
  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchTypeAddress()
    } else {
      this.getTypeAddress()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          ativo: item.ativo == 'S' ? 'Ativo' : 'Inativo',
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getTypeAddress() {
    this.loading = true
    this.addressTypeService
      .listPagedAddressType(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedAddressTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchTypeAddress() {
    this.loading = true
    this.addressTypeService
      .searchPagedAddressType(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedAddressTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editAddress(item: any) {
    const dialogRef = this.dialog.open(AddressTypeEditComponent, {
      minWidth: '700px',
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteAddress(item: any) {
  }
}
